import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, GoogleAuthProvider,
  signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";
import { getDatabase, ref, get, child, update, push, remove, set } from "firebase/database"
import { deleteIdFromPathColor, getColoredList } from "./colors.js";
import moment from 'moment';

const firebaseConfig = {
  apiKey: "AIzaSyDneqCssyBLNN1DEdOhsItB2Otgzv1oYOg",
  authDomain: "nottebukk.firebaseapp.com",
  databaseURL: "https://nottebukk-default-rtdb.firebaseio.com",
  projectId: "nottebukk",
  storageBucket: "nottebukk.appspot.com",
  messagingSenderId: "228870138757",
  appId: "1:228870138757:web:3a751737b134bf71dab2ec"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);

const handleAuthChange = (func) => {
  return onAuthStateChanged(auth, func);
}

const onLoginEvent = (setUserLoggedIn) => {
  return handleAuthChange((user) => {
    if (user && user.emailVerified) {
      localStorage.setItem("uid", user.uid);
      setUserLoggedIn(true);
    } else {
      localStorage.setItem("uid", null);
      setUserLoggedIn(false);
    }
  });
}

const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  result.user;
};

const handleLogin = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password);
};

const handleLogup = async (email, password) => {
  return await createUserWithEmailAndPassword(auth, email, password);
};

const handleForgot = async (email) => {
  return await sendPasswordResetEmail(auth, email);
};

const handleSendPasswordResetEmail = async (email) => {
  return await sendPasswordResetEmail(auth, email);
}
const handleLogout = () => {
  auth.signOut();
}

const PLATFORM = "firebase";

const addRecord = async (path, record) => {
  record.updated_at = moment().format("YYYY-MM-DD HH:mm:ss");
  try{
    const userId = localStorage.getItem("uid");
    const dbRef = ref(db, `${userId}/${path}`);
    await push(dbRef, record);
    return [record, null]
  }
  catch(error){
    return [null, error]
  }
}

const setRecord = async (path, record) => {
  try{
    const userId = localStorage.getItem("uid");
    const dbRef = ref(db, `${userId}/${path}`);
    await set(dbRef, record);
    return [record, null]
  }
  catch(error){
    return [null, error]
  }
}

const updateRecord = async (path, recordId, record) => {
  if (path == "categories" && recordId == "list") {
    var list = record.list;
    var newList = {};
    for (let i = 0; i < list.length; i++) {
      list[i].updated_at = moment().format("YYYY-MM-DD HH:mm:ss");
      newList[list[i].id] = list[i];
    }
    const userId = localStorage.getItem("uid");
    const dbRef = ref(db, `${userId}/${path}`);
    await set(dbRef, newList);
    return [record, null]
  }
  record.updated_at = moment().format("YYYY-MM-DD HH:mm:ss");
  try{
    const userId = localStorage.getItem("uid");
    const dbRef = ref(db, `${userId}/${path}/${recordId}`);
    await update(dbRef, record);
    return [record, null]
  }
  catch(error){
    return [null, error]
  }
}

const deleteRecord = async (path, recordId) => {
  try{
    const userId = localStorage.getItem("uid");
    const dbRef = ref(db, `${userId}/${path}/${recordId}`);
    await remove(dbRef);
    deleteIdFromPathColor(path, recordId);
    return [null, null]
  }
  catch(error){
    return [null, error]
  }
}

const listRecords = async (path) => {
  try{
    const dbRef = ref(db);
    const userId = localStorage.getItem("uid");
    var snapshot = await get(child(dbRef, `${userId}/${path}`));
    if (snapshot.exists()) {
      return [snapshot.val(), null]
    }
    return [[], null]
  }
  catch(error){
    return [null, error]
  }
}

const fetchRecords = async (path, queryParam = {}) => {
  try{
    const dbRef = ref(db);
    const userId = localStorage.getItem("uid");
    const snapshot = await get(child(dbRef, `${userId}/${path}`));
    const data = snapshot.val()
    if (!data) {
      return [[], null]
    }
    var list = Object.keys(data).map((key) => {
      return {
        id: key,
        ...data[key],
      };
    })

    if (queryParam && queryParam.noSort) {
      return [list, null]
    } else {
      //desc due date
      if (path === "links" || path === "instructions" || path === "logs") {
        list = list.sort((a, b) => a.title.localeCompare(b.title, undefined, {sensitivity: 'base'}))
      } else if (path === "categories") {
        list = list.sort((a, b) => a.order - b.order)
      } else {
        list = list.sort((a, b) => b.updated_at.localeCompare(a.updated_at, undefined, {sensitivity: 'base'}))
      }
    }
    return [getColoredList(list, path), null]
  }
  catch(error){
    return [null, error]
  }
}

export {
  PLATFORM as PLATFORM, onLoginEvent as onLoginEvent, handleLogout as handleLogout,
  doSignInWithGoogle as doSignInWithGoogle, handleLogin as handleLogin,
  handleLogup as handleLogup, handleForgot as handleForgot, listRecords as listRecords,
  addRecord as addRecord, updateRecord as updateRecord, setRecord as setRecord,
  deleteRecord as deleteRecord, fetchRecords as fetchRecords,
  handleSendPasswordResetEmail as handleSendPasswordResetEmail, handleAuthChange as handleAuthChange
};

/*
import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;

  // add user to firestore
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};
*/